import { render, staticRenderFns } from "./SPRSimpleDropdown.vue?vue&type=template&id=72da790e&scoped=true"
import script from "./SPRSimpleDropdown.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleDropdown.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleDropdown.vue?vue&type=style&index=0&id=72da790e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da790e",
  null
  
)

export default component.exports